import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=699b2fa8&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=699b2fa8&prod&lang=scss&scoped=true"
import style1 from "./Friend.vue?vue&type=style&index=1&id=699b2fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699b2fa8",
  null
  
)

export default component.exports